import React from 'react'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import { getClassNames } from '@helpers/productWidgetHelper'
import { extractIdFromContent } from '@utils/extractId'
import styles from './stickerCard.module.scss'

const StickerCard = ({ data }) => {
  const { isSemPage } = data ?? {}
  const { sectionHeading, stickerCards, headerTabName } = data?.data?.attributes ?? {}

  const containerClassName = getClassNames([styles.rootContainer], {
    [styles.seoStyles]: !isSemPage,
  })

  return (
    <ErrorBoundary data={data}>
      <div className={containerClassName} id={extractIdFromContent(sectionHeading, headerTabName)}>
        <div className={styles.sectionHeading} dangerouslySetInnerHTML={{ __html: sectionHeading || '' }} />
        <div className={styles.cardsContainer}>
          {stickerCards?.map((sticker, index) => (
            <div key={index} className={styles.stickerStyles} style={{ background: sticker?.stickerBgColour }}>
              <span className={styles.heading}>{sticker?.stickerHeading}</span>
              <span className={styles.subHeading}>{sticker?.stickerSubHeading}</span>
              <span className={styles.bigText}>{sticker?.stickerBigText}</span>
              <span className={styles.description}>{sticker?.stickerDescription}</span>
            </div>
          ))}
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default StickerCard
